/**
 * One list of what goes stale when an itinerary row is written.
 *
 * There were four places that could add a row — the Steward research card, the
 * Steward day card, the disclosed-backbone card, and the manual add dialog —
 * and each kept its own hand-written list of query keys to invalidate. They had
 * already drifted: the manual dialog refreshed only `tripPlan`, so the printed
 * itinerary kept the old rows, and NOTHING anywhere invalidated `completeness`,
 * so the rail could go on calling a day empty after the traveler had filled it.
 *
 * A per-caller list is the wrong shape for this. A row written is a row
 * written; every view of the trip is downstream of it. Add a new trip view and
 * its key belongs here, once.
 */
import type { QueryClient } from "@tanstack/react-query";

/** Every query whose answer can change when an itinerary_items row is written. */
export const ITINERARY_WRITE_KEYS = [
  "itinerary",
  "tripPlan",
  "trip",
  "completeness",
  "stewardOpener",
  "stewardBackbone",
] as const;

/** Refresh every trip view after an itinerary row is created, edited or removed. */
export function invalidateAfterItineraryWrite(qc: QueryClient, tripId: string): void {
  for (const key of ITINERARY_WRITE_KEYS) {
    qc.invalidateQueries({ queryKey: [key, tripId] });
  }
}
